import React from 'react';
import PageTemplatePreview from 'components/projects/pages/templates/PageTemplatePreview';
import ExamplePagePreview from 'components/projects/pages/templates/ExamplePagePreview';
import { PageTemplateId } from 'data/v3/templates/pages/types';
import { ExamplePageId } from '../examples/examplePages';

type PreviewContentProps = {
  pageTemplateId: PageTemplateId | ExamplePageId;
  onCreateFromTemplate: (templateId: PageTemplateId | ExamplePageId) => void;
  onDelete: (deletedId: PageTemplateId) => void;
  onClose: () => void;
};

const PreviewContent = ({
  pageTemplateId,
  onCreateFromTemplate,
  onDelete,
  onClose,
}: PreviewContentProps) => {
  if (!pageTemplateId) {
    return null;
  }

  if (typeof pageTemplateId === 'number') {
    return (
      <PageTemplatePreview
        pageTemplateId={pageTemplateId}
        onCreateFromTemplate={onCreateFromTemplate}
        onDelete={onDelete}
        onClose={onClose}
      />
    );
  }

  // TODO: Remove when page examples are migrated to the backend
  if (typeof pageTemplateId === 'string') {
    return (
      <ExamplePagePreview
        pageTemplateId={pageTemplateId}
        onCreateFromTemplate={onCreateFromTemplate}
        onClose={onClose}
      />
    );
  }

  return null;
};

export default PreviewContent;
